<template>
  <div class="mx-md-12 px-sm-12 align--center text-center">
    <p class="display-1 primary--text text-center">Unser Haus</p>

    <v-col cols="12" sm="12" align="justify">
      <v-row>
      <v-col>
        Unser Alten- und Pflegeheim befindet sich nahe dem Marktzentrum in der Badstraße 10. 
        Durch den angrenzenden weitläufigen Park ist die Lage sehr ruhig. 
        Im Herbst 2006 wurde das komplett sanierte und erweiterte Gebäude nach einer mehrjährigen 
        Bauphase wieder bezogen. Im Erdgeschoss befinden sich der große Veranstaltungsraum, 
        die großen Terrassen im Süden und im Norden, die Küche, die Verwaltung, Frisör und Kapelle.
        Unsere 78 Einbettzimmer mit Duschbad sind gleichmäßig auf drei Wohnbereiche zu je 26 
        Zimmern verteilt. Gemeinsam genutzt werden die Aufenthaltsbereiche und die 
        gemeinschaftlichen Balkone. Fast die Hälfte der Zimmer verfügt über einen eigenen Balkon. 
        Im Zimmer gibt es die Anschlussmöglichkeit für ein Telefon. 
        Zur Nutzung der Fernsehkanäle benötigen Sie ein Liwest-Kabelfernsehmodul. 
        Gerne können Sie einen Termin vereinbaren und sich selbst ein Bild von unserem Haus machen.
        Unsere Küche, die als Gesunde Küche vom Land Oberösterreich ausgezeichnet ist, 
        versorgt das gesamte Haus zu allen Mahlzeiten mit frisch gekochten Gerichten. 
        Überdies werden auch die Kinder in Kinderbildungseinrichtungen sowie Personen, die sich Essen zu Hause liefern lassen, versorgt.
      </v-col>
      
      <v-col class="hidden-sm-and-down"
        cols="5">
        <v-card flat tile class="d-flex">
          <Diashow :bilder="bilder_haus"/>
        </v-card>
      </v-col>
      </v-row>
    </v-col>


    <Diashow class="hidden-md-and-up" :bilder="bilder_haus" width="100%"/>


    <p class="text-center title primary--text mt-3 mb-1">Woher kommt die Abwechslung?</p>

    <v-col cols="12" sm="12" align="justify">
      <v-row>
      <v-col>
        Viele engagierte Mitarbeiterinnen und Mitarbeiter erkennen Wünsche und Bedürfnisse, 
        der ihnen anvertrauten Personen und überlegen sich passende und fördernde Angebote, 
        die auch die Traditionen berücksichtigen, wie Kekse backen, Ostereier färben oder Blumen umtopfen. 
        Einmal im Jahr dürfen die meisten Bewohner auf einen Heimausflug mitfahren. 
        Viel Freude und Abwechslung bereiten die Besuche der Familie und Freunde, die jederzeit willkommen sind. 
        Unsere ehrenamtlich Mitarbeitenden, die regelmäßig kommen sind gern gesehene Gäste beim Nachmittagskaffee oder bei unseren Festen. 
        Die organisierten einmaligen Veranstaltungen und Aktivitäten sind: Faschingsball, Palmbuschen-Binden, 
        Muttertagsfeier, Knacker grillen beim Petersfeuer, Grillfest, Oktoberfest, Weihnachtsmarkt und Weihnachtsfeier. 
        Monatlich veranstalten wir eine Singrunde und Frauen- und Männerstammtische. <br>
        Zusätzlich bietet die MAS Alzheimerhilfe wöchentlich ein Gedächtnis- und Beschäftigungstraining an.

      </v-col>
      
      <v-col class="hidden-sm-and-down"
        cols="5">
        <v-card flat tile class="d-flex">
          <Diashow :bilder="bilder_feste"/>
        </v-card>
      </v-col>
      </v-row>
    </v-col>

    <Diashow class="hidden-md-and-up" :bilder="bilder_feste" width="100%"/>
  </div>
</template>

<script>
  export default {
    name: 'unser_haus',

    components: {
      Diashow: () => import("@/components/core/Diashow")
    },

    data() {
      return {
        bilder_haus: [
          {
            titel: "Unser Haus",
            bild: require('@/assets/Ueber_Uns/Unser_Haus/Haus/heim.jpg'),
          },
          {
            titel: "Terrasse",
            bild: require('@/assets/Ueber_Uns/Unser_Haus/Haus/Terrasse.jpg')
          },
          {
            titel: "Zimmer mit Blumen",
            bild: require('@/assets/Ueber_Uns/Unser_Haus/Haus/Zimmer_Blumen.jpg'),
          },
          {
            titel: "Zimmer mit Deko",
            bild: require('@/assets/Ueber_Uns/Unser_Haus/Haus/Zimmer_Deko.jpg')
          },
          {
            titel: "Zimmer",
            bild: require('@/assets/Ueber_Uns/Unser_Haus/Haus/Zimmer.jpg')
          },
        ],

        bilder_feste: [
          {
            titel: "Attersee",
            bild: require('@/assets/Ueber_Uns/Unser_Haus/Feste/Attersee.jpg'),
          },
          {
            titel: "Knacker_grillen",
            bild: require('@/assets/Ueber_Uns/Unser_Haus/Feste/Knacker_grillen.jpg')
          },
          {
            titel: "Maibaum",
            bild: require('@/assets/Ueber_Uns/Unser_Haus/Feste/Maibaum.jpg'),
          },
          {
            titel: "Singrunde",
            bild: require('@/assets/Ueber_Uns/Unser_Haus/Feste/Singrunde.jpg')
          },
        ],
      }
    }
  }
</script>
